import ArrIcon from './component'

export default ArrIcon
